export function customSelect() {
    if ($("select").length) {
        jcf.setOptions("Select", {
            wrapNative: false,
            flipDropToFit: false,
            fakeDropInBody: false,
            maxVisibleItems: 8
        });
        $("select").each(function () {
            let $this = $(this);
            $this.on("change", function () {
                if (this.value.length) {
                    $this.parent(".jcf-select").addClass("selected").removeClass("error");
                    $this.siblings(".jcf-select").addClass("selected").removeClass("error");
                } else {
                    $this.parent(".jcf-select").removeClass("selected").addClass("error");
                    $this.siblings(".jcf-select").removeClass("selected").addClass("error");
                }
            });
        });

        jcf.replaceAll();
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js